import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryQualityInspectionStatusList extends BaseModelAPI {

	static entity = 'deliveryqualityinspectionstatuslist'
	static entityName = 'deliveryqualityinspectionstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
